export const largeBreakpoint = '@media screen and (min-width: 958px)';
export const smallBreakpoint = `@media screen and (max-width: 957px)`;
export const small800Breakpoint = `@media screen and (max-width: 800px)`;
